/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-16 10:03:09
 * @LastEditTime: 2019-10-19 14:41:07
 * @LastEditors: Please set LastEditors
 */
/// <summary>
/// 建议项
/// </summary>
export class  SuggestItemInfo  {

	constructor()
	{
		this.address = null;
		this.gbCode = null;
		this.name = null;
	}

	
	

	static  GetBusPlanSuggestItem(jsonObj)
		{	
			let suggestItem=null;
			if(jsonObj==null)return suggestItem;
			suggestItem=new SuggestItemInfo();
			suggestItem.address = jsonObj.address;
			suggestItem.gbCode = jsonObj.gbCode;
			suggestItem.name = jsonObj.name;
			return suggestItem;
		}

}//end SuggestItemInfo

